import BaseResetButton from '@/base/BaseResetButton.vue'

export const courseSessionCommon = {
  components: {
    CommonFilter: () => import('@/components/Filters/PageCommonFilter.vue'),
    PersonSearchFilter: () => import('@/components/Filters/PersonSearchFilter.vue'),
    IdFilter: () => import('@/components/Filters/IdFilter.vue'),
    StatusFilter: () => import('@/components/Filters/StatusFilter.vue'),
    RangeCalendar: () => import('@/plugins/DateRangeInput.vue'),
    BaseCalendarWrap: () => import('@/base/BaseCalendarWrap'),
    BaseResetButton: BaseResetButton
  },
  props: {
    person: {
      type: Object,
      required: true
    },
    id: {
      type: Number,
      required: false
    },
    statuses: {
      type: Array,
      required: false
    },
    dates: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    localPerson: { id: null },
    localId: null,
    localStatuses: [],
    localDates: {
      startDate: null,
      endDate: null
    }
  }),
  watch: {
    statuses() {
      this.localStatuses = this.statuses.slice()
    },
    person() {
      this.localPerson = Object.assign({}, this.person)
    }
  },
  mounted() {
    this.localPerson = Object.assign({}, this.person)
    this.localId = this.id ? this.id : null
    this.localStatuses = this.statuses.length > 0 ? this.statuses.slice() : []
    if (this.dates) {
      this.localDates.startDate = this.dates.startDate.toDate()
      this.localDates.endDate = this.dates.endDate.toDate()
    }
  },
  methods: {
    selectPerson(data) {
      this.localPerson = data
    },
    clearDates() {
      this.changeDates(null, null)
    },
    changeDates(start, end) {
      this.localDates.startDate = start
      this.localDates.endDate = end
    }
  }
}
